import SwitchAccountMenuItems from './SwitchAccountMenuItems';

const DialogSwitchUserAccountMobile = () => <SwitchAccountMenuItems isMobile />;

export default DialogSwitchUserAccountMobile;
